import React, { ReactNode, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { AuthState } from '@okta/okta-auth-js';
import { useRefreshAccessToken } from '../useRefreshAccessToken';

type Props = {
  children: ReactNode;
};

export function OktaHelper(props: Props) {
  const { children } = props;
  const { authState, oktaAuth } = useOktaAuth();
  const refreshAccessToken = useRefreshAccessToken();

  // This useEffect hook was initially written by Andrea in modified local copy of Security component.
  // Since we are using standard unmodified okta-react now, moving this hook here.
  useEffect(() => {
    if (!oktaAuth) {
      return;
    }
    const onAuthStateChange = (authState: AuthState) => {
      (window as any).ImAuthState = authState;
    };
    oktaAuth.authStateManager.subscribe(onAuthStateChange);

    // Trigger an initial change event to make sure authState is latest
    oktaAuth.start();

    return () => {
      oktaAuth.authStateManager.unsubscribe(onAuthStateChange);
      oktaAuth.stop();
    };
  }, [oktaAuth]);

  useEffect(() => {
    if (!oktaAuth || !authState) {
      return;
    }

    const onTokenRefresh = () => {
      refreshAccessToken();
    };
    oktaAuth.tokenManager.on('expired', onTokenRefresh);

    return () => {
      oktaAuth.tokenManager.off('expired', onTokenRefresh);
    };
  }, [oktaAuth, authState, refreshAccessToken]);

  return <>{children}</>;
}
